import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ChevronLeft, ChevronRight } from "react-feather";
import trackingEventDictionary from "../../core/dictionary/tracking-event";
import { generateTrackingObject } from "../../core/global/global-country-functions";
import { trademoTrackingEvents } from "../../core/global/trademo-tracking";
import commaFormat from "../../utils/commaFormat";
import NoSearchDataComponent from "../country-components/no-search-data";

const safeValue = (v) => (v && v.value ? v.value : 1);

const ViewAllTwoLevelAnalytics = ({ customStyles, columns, twolevelData, currentKeyViewTrendItem, levelTwoNextPageHandler, count, setDefaultPage, defaultPage, setMaxPaginate, maxPaginate, viewAllPerPage, setViewAllPerPage, pathname, analyticsCountryID, currentUserPlan, secondLevelRowDropdownValue }) => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState("");
  const currentClass = !currentKeyViewTrendItem.grpType ? "lvl-two-table-container" : "lvl-two-table-container-route";
  const perPageGroups = Math.max(1, Math.floor(viewAllPerPage / safeValue(secondLevelRowDropdownValue)));

  const fieldHandler = (row, obj) => {
    if (row?.field4) obj.subFields4 = row.field4;
    if (row?.field3) obj.subFields3 = row.field3;
    if (row?.field2) obj.subFields2 = row.field2;
    if (row?.field1) obj.subFields1 = row.field1;
  };

  useEffect(() => {
    if (!twolevelData || !twolevelData.length) {
      setData([]);
      return;
    }

    const startIndex = (defaultPage - 1) * perPageGroups;
    const endIndex = startIndex + perPageGroups - 1;

    if (!twolevelData[endIndex] && endIndex < count) {
      levelTwoNextPageHandler("paginate");
      return;
    }

    const array = [];
    for (let i = startIndex; i <= endIndex; i++) {
      if (!twolevelData[i]) continue;
      const item = twolevelData[i];
      if (item.sub_data && item.sub_data.length) {
        item.sub_data.forEach((val, index) => {
          const obj = { ...val, ...item };
          obj.key = item.key;
          obj.subKey = val.key;
          obj.total = item.total_value;
          obj.s_no = index + 1;
          fieldHandler(val, obj);
          obj.showBorder = index + 1 === item.sub_data.length;
          array.push(obj);
        });
      } else {
        const obj = { ...item };
        obj.key = item.key;
        obj.subKey = "NA";
        obj.total = item.total_value;
        obj.s_no = 1;
        obj.showBorder = true;
        array.push(obj);
      }
    }

    setData([]);
    setTimeout(() => setData([...array]), 100);
  }, [defaultPage, viewAllPerPage, pagination, twolevelData, secondLevelRowDropdownValue, count]);

  useEffect(() => {
    const val = document.querySelectorAll(`.${currentClass} .rdt_Pagination select option`);
    if (val && val.length >= 2) {
      val[0].textContent = 2;
      val[1].textContent = 5;
    }

    const range = document.querySelectorAll(`.${currentClass} .rdt_Pagination span`);
    if (range && range.length) {
      const startIndex = (defaultPage - 1) * perPageGroups;
      const endIndex = Math.min(startIndex + perPageGroups - 1, count - 1);
      range[1].textContent = `${startIndex + 1} - ${Math.max(Math.min(endIndex + 1, count), startIndex + 1)} of ${commaFormat(count)}`;
    }

    const prevPage = document.querySelectorAll(`.${currentClass} #pagination-previous-page`);
    if (prevPage && prevPage.length) {
      if (defaultPage > 1) prevPage[0].removeAttribute("disabled");
      else prevPage[0].setAttribute("disabled", true);
    }

    const nextPage = document.querySelectorAll(`.${currentClass} #pagination-next-page`);
    if (nextPage && nextPage.length) {
      if (defaultPage * perPageGroups >= count) nextPage[0].setAttribute("disabled", true);
      else nextPage[0].removeAttribute("disabled");
    }

    const rows = document.querySelectorAll(`.${currentClass} .rdt_TableRow`);
    if (rows && rows.length) {
      data.forEach((item, index) => {
        if (!item.showBorder && rows[index]) {
          const firstChild = rows[index].firstChild;
          firstChild.style.borderBottom = "none";
        }
      });
    }

    const pagination = document.querySelectorAll(`.${currentClass} .rdt_Pagination`);
    if (pagination && pagination.length && data && data.length < 8) {
      pagination[0].style.marginTop = -(48 * (10 - data.length)) + 30 + "px";
    }
  }, [data, defaultPage, viewAllPerPage, secondLevelRowDropdownValue, count]);

  const handleNextPage = () => {
    if (defaultPage * perPageGroups >= count) return;
    setDefaultPage(defaultPage + 1);
    if (defaultPage >= maxPaginate) setMaxPaginate(maxPaginate + 1);
    setPagination("next");
    trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletViewAll2ndLevelAnalyticsPaginationForward, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
  };

  const handlePrevPage = () => {
    if (defaultPage > 1) {
      setDefaultPage(defaultPage - 1);
      setPagination("prev");
    }
    trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletViewAll2ndLevelAnalyticsPaginationBackward, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
  };

  return <div className={`twolevel ${currentClass}`}>{!!columns && columns.length && data.length ? <DataTable title="Companies" columns={columns} className="trademo-datatable trademo-custom-table2" data={data} customStyles={customStyles} pagination persistTableHead highlightOnHover paginationIconFirstPage={<></>} paginationIconLastPage={<></>} paginationIconPrevious={<ChevronLeft color={defaultPage > 1 ? "rgba(0,0,0,0.54)" : "#D1D1D1"} onClick={handlePrevPage} />} paginationIconNext={<ChevronRight onClick={handleNextPage} />} noDataComponent={<NoSearchDataComponent content="No Shipments Found. Please try another search" />} paginationTotalRows={count} paginationRowsPerPageOptions={[safeValue(secondLevelRowDropdownValue) * 2, safeValue(secondLevelRowDropdownValue) * 5]} paginationPerPage={viewAllPerPage} onChangeRowsPerPage={(rows) => setViewAllPerPage(rows)} paginationDefaultPage={defaultPage} /> : null}</div>;
};

export default ViewAllTwoLevelAnalytics;
